module.exports = __webpack_public_path__ + "static/media/4.cdab6f09.svg";